import { useUnit } from 'effector-react';
import { Backdrop, CircularProgress } from '@mui/material';
import { $isLoading, $isLocalLoading } from '../../model/save';

export const Loader = () => {
  const [isLoading, isLocalLoading] = useUnit([$isLoading, $isLocalLoading]);

  if (!isLoading && !isLocalLoading) return null;

  return (
    <Backdrop open>
      <CircularProgress size={20} />
    </Backdrop>
  );
};
